import state from './campaigns.state'
import mutations from './campaigns.mutations'
import actions from './campaigns.actions'
import getters from './campaigns.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
